/**
 * Trip membership API service.
 */
import { AxiosResponse } from 'axios';
import { BaseApiService } from './baseApi';
import { TRIPS, MEMBERSHIPS } from '../../constants';
import { TripMembership } from '../../types';
import { ServiceResult } from '../../types/common/api.types';

export class MembershipApiService extends BaseApiService {
  async createMyMembership(
    tripId: string
  ): Promise<ServiceResult<TripMembership>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<TripMembership> = await this.api.post(
        `${TRIPS}/${tripId}${MEMBERSHIPS}`
      );
      return response.data;
    });
  }
}
